import {Component, Inject, OnInit} from '@angular/core';
import {BaseCustomDialog} from '../base-custom-dialog';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ACTION_DATA_SERVICE, ActionDataService} from '../../../../services/action/data.service';
import {DateTimeHelper, TimePeriodType} from '../../../../helper/date-time.helper';
import {ActionIconHelper} from '../../../../helper/action-icon.helper';
import {UserTokenService} from '../../../../services/user-service/user-token.service';
import {AppointmentsHelper} from '../../../../helper/appointments.helper';
import { ICompanyContacts, IContact } from '../../../../models/leads/leads.model';
import {LEADS_DATA_SERVICE, LeadsDataService} from '../../../../services/leads/leads-data.service';

@Component({
  selector: 'fi-appointment-move-popup',
  templateUrl: './appointment-move-popup.component.html',
  styleUrls: ['./appointment-move-popup.component.scss'],
  standalone: false,
})
export class AppointmentMovePopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  selectedTypeId: number;
  readonly dateOptionTypes = DateTimeHelper.datePeriodTypes;

  searchedText = '';
  note = '';
  selectedDate: Date;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('APPOINTMENT_MOVE', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('APPOINTMENT_MOVE', true);
  submitting: boolean;
  companyContacts: ICompanyContacts[];
  contactToDisplay: IContact;
  appointmentExists = false;
  inValidNote = false;

  constructor(
    private userTokenService: UserTokenService,
    public dialogRef: MatDialogRef<AppointmentMovePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string },
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;

    this.leadsDataService.getLeadById(this.leadId).subscribe(({success, data}) => {
      if (success) {
        this.companyContacts = data.CompanyContacts;
        this.contactToDisplay = data.Contact;
      }
    });
  }

  onDateSelect(date: Date, time = false): void {
    this.selectedTypeId = null;

    if (!date) {
      this.selectedDate = null;
      return;
    }

    if (!this.selectedDate) {
      this.selectedDate = date;
    } else if (!time) {
      this.selectedDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    } else {
      this.selectedDate.setHours(date.getHours(), date.getMinutes());
    }

    this.selectedDate = new Date(this.selectedDate);


    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  onDateOptionSelected(typeId: number): void {
    const type = this.dateOptionTypes.find(x => x.Id === typeId);
    this.selectedTypeId = type.Id;
    this.selectedDate = DateTimeHelper.getDateAfterPeriod(type);
    this.appointmentExists = AppointmentsHelper.getAppointments(this.selectedDate, this.appointmentExists);
  }

  async ngOnInit(): Promise<void> {
    const userId = await this.userTokenService.getId();
    AppointmentsHelper.getDbAppointments(this.actionDataService, userId);
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    return !!this.leadId && !!this.selectedDate && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {

    if (this.formIsValid) {
      this.submitting = true;
      this.actionDataService.moveAppointment(this.leadId, this.note, this.selectedDate)
        .subscribe(({success, data}) => {
          if (success) {
            this.clearClassAndCloseDialog(this.dialogRef, 'remove');
          }

          this.submitting = false;
        });
    }
  }
}
